let globalVisibilityState: boolean | null = null

document.addEventListener('pointerup', () => (globalVisibilityState = null))

export function useMouseOverVisibilityToggle({
  toggleRef,
  visible,
  setVisible,
}: {
  toggleRef: Ref<HTMLElement | null>
  visible: Ref<boolean>
  setVisible: (visible: boolean) => void
}): void {
  onMounted(() => {
    toggleRef.value?.addEventListener('pointerdown', _handleSetGlobalVisibilityState)
    toggleRef.value?.addEventListener('pointerenter', _handleMouseOver)
    toggleRef.value?.addEventListener('touchstart', _preventDefault, { passive: true })
  })

  onUnmounted(() => {
    toggleRef.value?.removeEventListener('pointerdown', _handleSetGlobalVisibilityState)
    toggleRef.value?.removeEventListener('pointerenter', _handleMouseOver)
    toggleRef.value?.removeEventListener('touchstart', _preventDefault)
  })

  function _preventDefault(e: TouchEvent) {
    e.preventDefault()
  }

  function _handleSetGlobalVisibilityState(e: PointerEvent): void {
    const isPrimary = e.buttons === 1 || e.isPrimary
    e.preventDefault()
    if (isPrimary) {
      globalVisibilityState = !visible.value
      setVisible(globalVisibilityState)
      ;(e.target as HTMLElement)?.releasePointerCapture(e.pointerId)
    }
  }

  function _handleMouseOver(e: PointerEvent): void {
    const isPrimary = e.buttons === 1 || e.isPrimary
    e.preventDefault()
    if (isPrimary && globalVisibilityState !== null) {
      setVisible(globalVisibilityState)
    }
  }
}
